import type { Routes } from '../../shares/types';
import { BreadcrumbBasic } from './basic';

export const BREADCRUMB_ROUTES: Routes = {
	breadcrumb: {
		basic: BreadcrumbBasic,
	},
};
